import axios from "axios";
import { toast } from "react-toastify";

const instance = axios.create();

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
    }
    if (error?.response.data) {
      if (error?.response.data.message !== "The given data was invalid.") {
        toast.error(error?.response.data.message);
      }
      if (error?.response.data.errors) {
        let errors = error?.response.data.errors;
        Object.keys(errors).forEach((key) => {
          errors[key].forEach((error) => {
            toast.error(error);
          });
        });
      }
    }
    return Promise.reject(error);
  }
);
export default instance;
